import { type ReactElement, type ReactNode } from "react"
import { RootState } from "src/app/store";
import { useSelector } from "react-redux";

export interface DealerReportProps {
        invoiceNumber: string,
        children?: ReactNode
}

export function DealerReport(props: DealerReportProps): ReactElement {

        const { dealerLoading, dealerError, dealer } = useSelector((state: RootState) => state.dealer);
        const { endUserForReportsLoading, endUserForReportsError, endUserForReports } = useSelector((state: RootState) => state.endUserForReports);
        let dealerAddress = "";
        if ((dealer.Addresses.Address1.length > 0) && (dealer.Addresses.City.length > 0) && (dealer.Addresses.State.length > 0) && (dealer.Addresses.Country.length > 0)) {
                dealerAddress = dealer.Addresses.Address1 + ", " + dealer.Addresses.City + ", " + dealer.Addresses.State + " - " + dealer.Addresses.Country;
        }

        return <>
                <div className="flex flex-col items-center gap-8 m-12">
                        <div className="flex flex-row justify-between w-full">
                                <h2 className="flex flex-col justify-center gap-4">
                                        <div className="flex justify-center">
                                                <p>{dealer.Name}</p>
                                        </div>
                                        <div className="flex justify-center flex-wrap">
                                                <p>{dealerAddress}</p>
                                        </div>
                                        <div className="flex justify-center">
                                                <p>{dealer.CreatedAt}</p>
                                        </div>
                                </h2>
                                <h2 className="flex flex-col gap-4">
                                        <div className="flex gap-4">
                                                <p className="font-bold">Invoice Number:</p>
                                                <p>{props.invoiceNumber}</p>
                                        </div>
                                        <div className="flex gap-4">
                                                <p className="">Billing Cycle:</p>
                                                <p>{dealer.Name}</p>
                                        </div>
                                </h2>
                        </div>
                        <table className="w-full">
                                <thead>
                                        <tr className="text-xs font-bold">
                                                <th className="text-center py-2 px-4">EndUserID</th>
                                                <th className="text-center py-2 px-4">EndUser Name</th>
                                                <th className="text-center py-2 px-4">Status</th>
                                                <th className="text-center py-2 px-4">Total DSX-Cloud System</th>
                                                <th className="text-center py-2 px-4">Total Locations</th>
                                                <th className="text-center py-2 px-4">Total Doors</th>
                                                <th className="text-center py-2 px-4">Total $</th>
                                        </tr>
                                </thead>
                                <tbody>
                                        {endUserForReports.map(endUser =>
                                                <tr className="text-xs">
                                                        <td className="text-center py-2 px-4">{endUser.EndUserId}</td>
                                                        <td className="text-center text-wrap py-2 px-4">{endUser.Name}</td>
                                                        <td className="text-center py-2 px-4">{endUser.Enabled ? "A" : "I"}</td>
                                                        <td className="text-center py-2 px-4">{endUser.TotalNumberOfCoreInstances == null ? 0 : endUser.TotalNumberOfCoreInstances.toString()}</td>
                                                        <td className="text-center py-2 px-4">{endUser.TotalNumberOfLocations == null ? 0 : endUser.TotalNumberOfLocations.toString()}</td>
                                                        <td className="text-center py-2 px-4">{endUser.TotalNumberOfDoors == null ? 0 : endUser.TotalNumberOfDoors.toString()}</td>
                                                        <td className="text-center py-2 px-4">{endUser.TotalCharges.toString()}</td>
                                                </tr>
                                        )}
                                </tbody>
                        </table>

                </div>
        </>
}
